import { render, staticRenderFns } from "./AgeCalculator.vue?vue&type=template&id=74d6a3ee&"
import script from "./AgeCalculator.vue?vue&type=script&lang=js&"
export * from "./AgeCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports